import { Routes } from '@common/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { parseDateToString } from '@utils/helpers';
import { ComponentProps, FC, useCallback } from 'react';
import { useRouter } from 'shared-routing';
import { DateCategoryPicker as DateCategoryPickerV1 } from '../JourneyPicker/DateCategoryPicker/DateCategoryPicker';
import { JourneyPickerV2Connected } from './container';
import type { JourneyPickerSearchParams } from './JourneyPickerV2';
import { useCategoryNavigation } from './useCategoryNavigation';
import { useNavCategories } from './useNavCategories';

type V1Props = ComponentProps<typeof DateCategoryPickerV1>;

const ROUTE_TO_CATEGORY: Record<string, string> = {
  [Routes.SPA_DAY_LIST]: 'spa-days',
  [Routes.SPA_TREATMENT_LIST]: 'spa-treatments',
  [Routes.FACILITY_LIST]: 'facilities',
};

function useActiveCategory(): string {
  const router = useRouter();
  const pathname = router.pathname || '';
  return ROUTE_TO_CATEGORY[pathname] || 'spa-days';
}

export const DateCategoryPickerVersion: FC<V1Props> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  const router = useRouter();
  const categories = useNavCategories();
  const handleCategoryChange = useCategoryNavigation();
  const activeCategory = useActiveCategory();

  const handleSearchComplete = useCallback(
    (params: JourneyPickerSearchParams) => {
      router.push(
        {
          pathname: router.pathname,
          query: { arrivalDate: parseDateToString(params.fromDate) },
        },
        undefined,
        { shallow: true }
      );
    },
    [router]
  );

  if (isV2) {
    return (
      <JourneyPickerV2Connected
        dateMode="single"
        dateContext="spa"
        showGuests
        categories={categories}
        category={activeCategory}
        onCategoryChange={handleCategoryChange}
        onSearchComplete={handleSearchComplete}
      />
    );
  }

  return <DateCategoryPickerV1 {...props} />;
};
